import { preload } from 'react-isomorphic-render';
import { connect } from 'react-redux';
import _ from 'lodash';
import { fetchOrderDetails, fetchConfirmationPage } from 'app/store/api/glowforge-store-api';
import ConfirmationPage from 'app/store/components/glowforge/confirmation/confirmation-page';

const mapStateToProps = state => ({
  page: { ..._.get(state, 'glowforgeStore.orderConfirmationPage') },
  priceSummary: _.get(state, 'glowforgeStore.priceSummary'),
  shippingSummary: _.get(state, 'glowforgeStore.shippingSummary'),
  referralURL: _.get(state, 'glowforgeStore.referralURL'),
  orderEmail: _.get(state, 'glowforgeStore.orderEmail'),
  gtmNewOrderConfig: _.get(state, 'glowforgeStore.gtmNewOrderConfig'),
});

const ShopCategoryContainer = connect(mapStateToProps)(preload(
  ({ dispatch, location, parameters }) => {
    const key = _.get(location, 'query.key');
    return Promise.all([
      dispatch(fetchOrderDetails(parameters.orderNumber, key)),
      dispatch(fetchConfirmationPage()),
    ]);
  })(ConfirmationPage),
);

export default ShopCategoryContainer;



// WEBPACK FOOTER //
// ./app/store/containers/glowforge/confirmation.js